import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../../shared/models/api-response.model';
import { SelectList } from '../../../shared/models/select-list';
import { HttpCommonService } from '../../../shared/services/http-common-service';
import { SearchTaskDto, TaskAddEditDto, TaskDashboardDto, TaskDto, UpdateStatusDto } from '../models/task-models';

@Injectable({
  providedIn: 'root'
})
export class TaskService {
  private baseUrl = `Task`;

  constructor(private httpCommonService: HttpCommonService) { }

  getDashboard(): Observable<ApiResponse<TaskDashboardDto>> {
    return this.httpCommonService.get<ApiResponse<TaskDashboardDto>>({
      url: `${this.baseUrl}/GetDashboard`
    });
  }

  search(searchDto: SearchTaskDto): Observable<ApiResponse<SearchTaskDto>> {
    return this.httpCommonService.post<ApiResponse<SearchTaskDto>>({
      url: `${this.baseUrl}/Search`,
      body: searchDto
    });
  }

  save(model: TaskAddEditDto): Observable<ApiResponse<string>> {
    return this.httpCommonService.post<ApiResponse<string>>({
      url: `${this.baseUrl}/Save`,
      body: model
    });
  }

  getById(id: string): Observable<ApiResponse<TaskDto>> {
    return this.httpCommonService.get<ApiResponse<TaskDto>>({
      url: `${this.baseUrl}/Get/${id}`
    });
  }

  delete(id: string): Observable<ApiResponse<string>> {
    return this.httpCommonService.delete<ApiResponse<string>>({
      url: `${this.baseUrl}/Delete/${id}`
    });
  }

  exists(id: string): Observable<ApiResponse<boolean>> {
    return this.httpCommonService.get<ApiResponse<boolean>>({
      url: `${this.baseUrl}/${id}/Exists`
    });
  }

  updateStatus(model: UpdateStatusDto): Observable<ApiResponse<boolean>> {
    return this.httpCommonService.put<ApiResponse<boolean>>({
      url: `${this.baseUrl}/UpdateStatus/${model.id}`,
      body: model
    });
  }

  startTask(taskId: string): Observable<ApiResponse<boolean>> {
    return this.httpCommonService.put<ApiResponse<boolean>>({
      url: `${this.baseUrl}/StartTask/${taskId}`
    });
  }

  stopTask(taskId: string): Observable<ApiResponse<boolean>> {
    return this.httpCommonService.put<ApiResponse<boolean>>({
      url: `${this.baseUrl}/StopTask/${taskId}`
    });
  }

  delayTask(taskId: string): Observable<ApiResponse<boolean>> {
    return this.httpCommonService.put<ApiResponse<boolean>>({
      url: `${this.baseUrl}/DelayTask/${taskId}`
    });
  }

  export(searchDto: SearchTaskDto): Observable<Blob> {
    return this.httpCommonService.post<Blob>({
      url: `${this.baseUrl}/Export`,
      body: searchDto,
      responseType: 'blob'
    });
  }

  getStatusList(): Observable<ApiResponse<SelectList[]>> {
    return this.httpCommonService.get<ApiResponse<SelectList[]>>({
      url: `${this.baseUrl}/GetStatusList`
    });
  }

  getPriorityList(): Observable<ApiResponse<SelectList[]>> {
    return this.httpCommonService.get<ApiResponse<SelectList[]>>({
      url: `${this.baseUrl}/GetPriorityList`
    });
  }

  getByItem(id: string): Observable<ApiResponse<TaskDto[]>> {
    return this.httpCommonService.get<ApiResponse<TaskDto[]>>({ url: `${this.baseUrl}/GetByItem/${id}` });
  }
}
